import { BaseApiRequest } from "../baseApiRequest";
import { XcoreCore } from "XcoreCore";
import { baseWebFetchOptions } from "./options";
import { resolveWebResetPasswordErrorParams, WebResetPasswordError } from "../errors";

export interface ResetPasswordParams {
  requestId: string;
  password: string;
  passwordConfirm: string;
}

/**
 * @throws {WebResetPasswordError}
 */
export const resetPassword = (core: XcoreCore, params: ResetPasswordParams): BaseApiRequest<Response> =>
  core
    .fetch("/api/web/reset-password", {
      ...baseWebFetchOptions,
      method: "POST",
      body: JSON.stringify(params),
    })
    .catch((err) => {
      const resetPasswordError = resolveWebResetPasswordErrorParams(err);
      if (resetPasswordError) {
        throw new WebResetPasswordError(resetPasswordError);
      }

      throw err;
    });
